<app-template-hexadecimal [disabled]="disabled" [value]="value" [control]="control" [label]="label" />
